/** Persian/Arabic digit normalization and safe numeric parsing helpers. */
const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
const arabicDigits = '٠١٢٣٤٥٦٧٨٩';

export function toEnglishNumbers(value: unknown): string {
  let result = String(value ?? '');
  for (let index = 0; index < 10; index += 1) {
    result = result.replaceAll(persianDigits[index] ?? '', String(index));
    result = result.replaceAll(arabicDigits[index] ?? '', String(index));
  }
  return result;
}

/** Converts Persian/Arabic digits and common Persian number separators to a browser/API friendly value. */
export function normalizeNumericText(value: unknown): string {
  return toEnglishNumbers(value)
    .replace(/[٬,\s]/g, '')
    .replace(/٫/g, '.')
    .replace(/[−–—]/g, '-');
}

/** Parses a finite number without accepting partial or non-numeric strings. */
export function parseNumericValue(value: unknown): number | undefined {
  const normalized = normalizeNumericText(value).trim();
  if (!/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(normalized)) return undefined;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : undefined;
}
